import { render } from "./port-fileupload-drop-area.vue?vue&type=template&id=b6c50998"
import script from "./port-fileupload-drop-area.vue?vue&type=script&lang=js"
export * from "./port-fileupload-drop-area.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__